import React from 'react';
import { Button, Container, Row } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';

const WorkComponent = () => {
    const history = useHistory();
    return (
        <>
            <Container fluid className="d-flex align-items-center" style={{ backgroundColor: "#C0C0C0" }}>
                    <Row style={{ marginTop: '40px' }}>
                        <div className="d-flex justify-content-center mt-3">
                            <p className="pages-end mb-0">Let's work together:</p>
                        </div>
                        <div className="d-flex justify-content-center text-center">
                            <p className="pages-end-para">Reach out to us to chat about how we can collaborate and deliver value.</p>
                        </div>
                        <div className="d-flex justify-content-center text-center mb-5 mt-3">
                            <Button variant="outline" type="submit" onClick={() => {
                                history?.push("/contact");
                            }} className="contact-btn rounded-3">
                                Contact Us
                            </Button>
                        </div>
                    </Row>
                </Container>
        </>
    )
}

export default WorkComponent;